export class CheckIngestionPipelineAccessRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ingestionPipelines",
            "baseName": "ingestionPipelines",
            "type": "Array<IngestionPipelineAccessSubject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckIngestionPipelineAccessRequest.attributeTypeMap;
    }
    constructor() {
    }
}
